import React, { MouseEvent } from 'react';
import { Dialog } from '../../../../../../components/Dialog';
import { Images } from '@ansvar-sakerhet/ui/src/assets/images';
import { useDeleteControlCompany } from '../../../../../../traits/api/controls/useDeleteControlCompany';
import { useControl } from '../../../../components/ControlLayout';
import { S } from './DeleteCompanyDialog.styles';

type Props = {
  companyId: string;
  onClose: () => void;
};

export const DeleteCompanyDialog: React.FC<Props> = (props) => {
  const { data } = useControl();
  const deleteCompany = useDeleteControlCompany(data.inspectionId, {
    onDeleteCompanySuccess: props.onClose,
  });

  const onCancel = (
    e: MouseEvent<HTMLButtonElement, globalThis.MouseEvent>
  ) => {
    e.stopPropagation();
    props.onClose();
  };

  return (
    <Dialog.Base onClose={props.onClose}>
      <img src={Images.Delete} width={295} height={215} />

      <Dialog.Title>
        <S.H5>Är du säker på att du vill radera bolaget?</S.H5>
      </Dialog.Title>

      <Dialog.Description>
        <S.H6>
          Bolaget och tillhörande data kommer inte kunna återställas.
        </S.H6>
      </Dialog.Description>

      <S.ButtonContainer>
        <Dialog.CancelButton>
          <S.Button $outlined onClick={onCancel}>
            Avbryt
          </S.Button>
        </Dialog.CancelButton>

        <Dialog.Button>
          <S.Button
            disabled={deleteCompany.isLoading}
            onClick={(e) => {
              e.stopPropagation();
              deleteCompany.mutate(props.companyId);
            }}
          >
            Ja, radera
          </S.Button>
        </Dialog.Button>
      </S.ButtonContainer>
    </Dialog.Base>
  );
};
